import { render, staticRenderFns } from "./UserAddList.vue?vue&type=template&id=31ba3028&"
import script from "./UserAddList.vue?vue&type=script&lang=js&"
export * from "./UserAddList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports